import { Box } from "@mui/material";

export const OssDataGridFrame = ({ children, height = 520, sx = {} }) => (
  <Box
    sx={{
      height,
      minHeight: 220,
      width: "100%",
      overflow: "hidden",
      border: "1px solid #e5e7eb",
      borderRadius: "8px",
      bgcolor: "#fff",
      "& .MuiDataGrid-root": {
        border: 0,
      },
      "& .MuiDataGrid-cell": {
        minWidth: 0,
      },
      "& .MuiDataGrid-columnHeaders": {
        overflow: "hidden",
      },
      "& .MuiDataGrid-scrollbar--vertical": {
        top: "var(--DataGrid-topContainerHeight, 56px) !important",
        height: "calc(100% - var(--DataGrid-topContainerHeight, 56px)) !important",
      },
      "& .MuiDataGrid-virtualScroller": {
        scrollbarWidth: "thin",
      },
      "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
        width: 8,
        height: 8,
      },
      "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb": {
        borderRadius: 999,
        backgroundColor: "#cbd5e1",
      },
      "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track": {
        backgroundColor: "#f8fafc",
      },
      ...sx,
    }}
  >
    {children}
  </Box>
);
